type FacebookStandardEvent = 'CompleteRegistration' | 'InitiateCheckout' | 'Purchase';

/**
 * Track a custom facebook event.
 * https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/
 *
 * @param name - event name
 * @param value - the event value.
 */
export const emitCustomEvent = (name: string, values?: Record<string, string>): void => {
  window.fbq?.('trackCustom', name, values);
};

export const emitStandardEvent = (
  name: FacebookStandardEvent,
  values?: Record<string, string | number | null>,
  eventId?: string,
): void => {
  window.fbq?.('track', name, values, eventId && { eventID: eventId });
};
